// Part of the landing page (split out of pages/Landing.js, 2026-09-24).

const PALETTE = {
  orange: '#FF9900', orangeSoft: '#FFF4E0', navy: '#131A22', navySoft: '#1F2933',
  bg: '#FBFAF7', ink: '#0F0F0F', muted: '#6B7280', line: '#E5E2DA', green: '#1F7A3A',
};

const CHART_POINTS = [199, 199, 195, 189, 189, 179, 179, 175, 169, 169, 165, 159, 155];
const CHART_TARGET = 160;

const HERO_PLACEHOLDERS = [
  'https://amazon.com/dp/B09JQMJHXY',
  'https://amazon.com.au/dp/B0C7M3D9PQ',
  'https://amazon.co.uk/dp/B08L5M2X8Z',
];

// True when the hero input reads like a keyword search ("airpods pro"),
// not a URL. Scheme-less domains ("amazon.com.au/dp/…") still count as URLs.
const looksLikeSearchQuery = (s) => {
  const t = s.trim();
  if (/^https?:\/\//i.test(t)) return false;
  return !/^[a-z0-9-]+(\.[a-z0-9-]+)+([/?#]|$)/i.test(t);
};

const timeAgo = (sec) => {
  if (sec == null || sec < 90) return 'just now';
  const m = Math.floor(sec / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
};

const alertTickerLine = (alert) => {
  const title = alert.title.length > 60
    ? `${alert.title.slice(0, 57).trimEnd()}…`
    : alert.title;
  return alert.type === 'BACK_IN_STOCK'
    ? `back in stock — ${title}`
    : `price drop on ${title}`;
};

const FAQ_ITEMS = [
  {
    q: 'How accurate is the price you email me?',
    a: "It's the exact listed price at the moment of our sweep — same number you'd see on Amazon if you opened the page yourself. We re-check every 24h and email within ~60s of a hit. No estimates, no rounding.",
  },
  {
    q: 'How often will you email me?',
    a: 'Only when your target hits. One email per product, ever. We do not send digests, marketing, or "you might also like" messages.',
  },
  {
    q: "Still have questions or need more details?",
    a: "Send us a message through the ",
    link: { label: "feedback form", href: "/feedback" },
    aSuffix: " — we read every one and reply personally. No bots, no ticket queues.",
  },
  {
    q: 'Which Amazon regions work?',
    a: '.com, .co.uk, .de, .fr, .it, .es, .ca, .com.au, .co.jp. Drop any product URL from these and we\'ll figure out the rest.',
  },
];

// link shape: { label, to } → React Router <Link>
//             { label, href } → plain <a> (hash anchors, external)
//             string → <span> (placeholder — no page yet, needs content)
const FOOTER_COLS = [
  { h: 'Product', links: [
    { label: 'How it works',     href: '#how-it-works' },
    { label: 'Live deals',       href: '#live-deals' },
    { label: 'Supported regions', href: '#faq' },
  ]},
  { h: 'Company', links: [
    { label: 'About',                to: '/about' },
    { label: 'Affiliate disclosure', to: '/legal' },
  ]},
  { h: 'Legal', links: [
    { label: 'Terms',   to: '/terms' },
    { label: 'Privacy', to: '/privacy' },
    { label: 'Legal',   to: '/legal' },
  ]},
  { h: 'Contact', links: [
    { label: 'Feedback', href: 'mailto:support@pricehuntify.com' },
  ]},
];

const COMPARISON_ROWS = [
  ['Time spent comparing prices', '~3.2 hrs / week', '0 hrs'],
  ['Items bought above target', '7 of 12', '0 of 12'],
  ['Total spent on wishlist', '$1,847', '$1,392'],
  ['Average savings per item', '$0', '$38'],
  ['Stress level', 'High', 'None'],
];

const WATCHLIST_ROWS = [
  ['Echo Dot (5th)', '$34.99', '$34.99', 'HIT', PALETTE.green],
  ['Kindle Paperwhite', '$119.99', '$99.00', '−$21', PALETTE.muted],
  ['AirPods Pro 2', '$189.00', '$179.00', '−$10', PALETTE.muted],
];

export { PALETTE, CHART_POINTS, CHART_TARGET, HERO_PLACEHOLDERS, looksLikeSearchQuery, timeAgo, alertTickerLine, FAQ_ITEMS, FOOTER_COLS, COMPARISON_ROWS, WATCHLIST_ROWS };
